import { NotificationOutlined } from "@ant-design/icons";

export const getTmsMenus = ({ isAll, isRoot, isAdmin, isStudentBuilding }) =>
    isAll || isAdmin
        ? [
              {
                  key: isAll ? "management" : "admin",
                  icon: "icon-dasbhoard",
                  label: "sidebar.dashboard",
                  to: `/${isAll ? "management" : "admin"}`,
              },
              {
                  key: "apartments",
                  icon: "icon-crm",
                  label: isStudentBuilding ? "Ole Student Management" : "sidebar.buildingDetails",
                  type: "submenu",
                  children: [
                      ...(isAll
                          ? [
                                {
                                    key: "buildings",
                                    icon: "icon-company",
                                    label: "sidebar.buildings",
                                    to: "/buildings",
                                },
                            ]
                          : []),
                      {
                          key: "apartment-list",
                          icon: "icon-home",
                          label: "sidebar.apartments",
                          to: "/apartment-list",
                      },
                      {
                          key: "tenants",
                          icon: "icon-widgets",
                          label: isStudentBuilding ? "Students" : "sidebar.tenants",
                          to: "/tenants",
                      },
                      {
                          key: "staffs",
                          icon: "icon-widgets",
                          label: isStudentBuilding ? "Ole Staffs" : "sidebar.staffs",
                          to: "/staffs",
                      },
                      {
                          key: "securement-fees",
                          icon: "icon-bitcoin",
                          label: "sidebar.securementFees",
                          to: "/securement-fees",
                      },
                      ...(!isStudentBuilding && isAll
                          ? [
                                {
                                    key: "payment-types",
                                    icon: "icon-tag",
                                    label: "sidebar.paymentTypes",
                                    to: "/payment-types",
                                },
                            ]
                          : []),
                      {
                          key: "notice-board",
                          icon: "icon-notification",
                          label: "sidebar.noticeBoard",
                          to: "/notice-board",
                      },
                      {
                          key: "welcome-pack",
                          icon: "icon-inbuilt-apps",
                          label: "sidebar.welcomePack",
                          to: "/welcome-pack",
                      },
                      ...(isStudentBuilding
                          ? [
                                {
                                    key: "events",
                                    icon: "icon-inbuilt-apps",
                                    label: "sidebar.events",
                                    to: "/events",
                                },
                                {
                                    key: "ole-peoples",
                                    icon: "icon-user",
                                    label: "Ole Peoples",
                                    to: "/ole-peoples",
                                },
                                {
                                    key: "pre-registration",
                                    icon: "icon-ellipse-v",
                                    label: "Pre-registration",
                                    to: "/pre-registration",
                                },
                            ]
                          : []),
                  ],
              },
              {
                  key: "tenants/blacklisted",
                  icon: "icon-user",
                  label: "sidebar.blackListedTenants",
                  to: "/tenants/blacklisted",
              },
              ...(isAll
                  ? [
                        {
                            key: "users",
                            icon: "icon-family",
                            label: "sidebar.users",
                            to: "/users",
                        },
                    ]
                  : []),
              {
                  key: "visitors",
                  icon: "icon-family",
                  label: "sidebar.visitors",
                  to: "/visitors",
              },
              ...(!isStudentBuilding
                  ? [
                        {
                            key: "vouchers",
                            icon: "icon-tag",
                            label: "sidebar.vouchers",
                            to: "/vouchers",
                        },
                    ]
                  : []),
              {
                  key: "reports",
                  icon: "icon-tasks",
                  label: "sidebar.reports",
                  to: "/reports",
              },
              ...(isRoot
                  ? [
                        {
                            key: "audit-log",
                            icon: "icon-files",
                            label: "sidebar.auditLog",
                            to: "/audit-log",
                        },
                        {
                            key: "unverified-payments",
                            icon: "icon-pricing-table",
                            label: "sidebar.unverifiedPayments",
                            to: "/unverified-payments",
                        },
                        {
                            key: "rent-due-gaps",
                            icon: "icon-widgets",
                            label: "sidebar.rentDueGaps",
                            to: "/rent-due-gaps",
                        },
                    ]
                  : []),
          ]
        : [];

export const getMarketingMenus = ({ isAll, isMarketing }) => {
    if (!isAll && !isMarketing) return [];

    const children = [
        {
            key: "marketing",
            icon: "icon-etherium",
            label: "sidebar.marketing",
            to: "/marketing",
        },
        {
            key: "advertisement-media",
            icon: "icon-etherium",
            label: "sidebar.advertisement-media",
            to: "/advertisement-media",
        },
    ];

    if (isAll) {
        children.push({
            key: "marketing-admin",
            icon: "icon-etherium",
            label: "sidebar.marketingAdmin",
            to: "/marketing-admin",
        });

        return [
            {
                key: "marketing-tools",
                icon: "icon-crm",
                label: "sidebar.marketingTools",
                type: "submenu",
                children,
            },
        ];
    }

    return children; // flat list for non-All users
};

export const getPushMenu = ({ isAll }) =>
    isAll
        ? [
              {
                  key: "push-notification",
                  icon: NotificationOutlined,
                  label: "sidebar.pushNotification",
                  to: "/push-notification",
              },
          ]
        : [];

export const getAppServiceMenus = ({ isAll, isRoot }) =>
    isAll
        ? [
              {
                  key: "App Services",
                  icon: "icon-crm",
                  label: "sidebar.app-services",
                  type: "submenu",
                  children: [
                      ...(isRoot
                          ? [
                                {
                                    key: "services",
                                    icon: "icon-etherium",
                                    label: "sidebar.services",
                                    to: "/services",
                                },
                            ]
                          : []),
                      {
                          key: "mobile-app-menu",
                          icon: "icon-setting",
                          label: "sidebar.mobile-app-menu",
                          to: "/mobile-app-menu",
                      },
                      ...(isRoot
                          ? [
                                {
                                    key: "tenant-service-settings",
                                    icon: "icon-setting",
                                    label: "sidebar.tenant-service-settings",
                                    to: "/tenant-service-settings",
                                },
                                {
                                    key: "building-service-settings",
                                    icon: "icon-setting",
                                    label: "sidebar.building-service-settings",
                                    to: "/building-service-settings",
                                },
                            ]
                          : []),
                  ],
              },
          ]
        : [];

export const getSettingsMenus = ({ isAll, isRoot }) =>
    isAll
        ? [
              {
                  key: "settings",
                  icon: "icon-setting",
                  label: "sidebar.settings",
                  type: "submenu",
                  children: [
                      {
                          key: "payment-account",
                          icon: "icon-bitcoin",
                          label: "sidebar.paymentAccount",
                          to: "/payment-account",
                      },
                      ...(isRoot
                          ? [
                                {
                                    key: "general-settings",
                                    icon: "icon-schedule",
                                    label: "sidebar.generalSettings",
                                    to: "/general-settings",
                                },
                            ]
                          : []),
                      ...(isRoot
                          ? [
                                {
                                    key: "email-settings",
                                    icon: "icon-email",
                                    label: "sidebar.emailSettings",
                                    to: "/email-settings",
                                },
                            ]
                          : []),
                      {
                          key: "laundry",
                          icon: "icon-etherium",
                          label: "sidebar.laundry",
                          to: "/laundry",
                      },
                      {
                          key: "kiosk-settings",
                          icon: "icon-apps",
                          label: "sidebar.kioskApp",
                          to: "/kiosk-settings",
                      },
                      ...(isAll
                          ? [
                                {
                                    key: "feature-flags",
                                    icon: "icon-folder",
                                    label: "sidebar.featureFlag",
                                    to: "/feature-flags",
                                },
                            ]
                          : []),
                      ...(isRoot
                          ? [
                                {
                                    key: "app-version-management",
                                    icon: "icon-apps",
                                    label: "sidebar.appVersionManagement",
                                    to: "/app-version-management",
                                },
                            ]
                          : []),
                  ],
              },
          ]
        : [];

export const getMaintenanceMenus = ({ isAdmin, isMainAdmin, hasMaintenanceAccess, isAll, maintenanceDepartments }) => {
    // Skip entirely if not isMainAdmin or isAll
    if (!isAll && !isAdmin && !hasMaintenanceAccess) {
        return [];
    }

    const children = [];

    // Base maintenance page
    children.push({
        key: "maintenance",
        icon: "icon-dasbhoard",
        label: "sidebar.maintenance",
        to: "/maintenance",
    });

    // task submenu all dept name with count
    const taskSubItems = [
        {
            key: "maintenance/tasks",
            icon: "icon-etherium",
            label: "All",
            to: "/maintenance/tasks",
        },
        ...maintenanceDepartments.map((dep) => ({
            key: `maintenance/tasks/${dep.id}`,
            icon: "icon-etherium",
            label: `${dep.name} (${dep.faults_count?.PENDING?.count ?? 0})`,
            to: `/maintenance/tasks/${dep.id}`,
        })),
    ];

    if (isAll || isAdmin || isMainAdmin) {
        children.push({
            key: "maintenance-tasks",
            icon: "icon-crm",
            label: "sidebar.maintenance-task",
            type: "submenu",
            children: taskSubItems,
        });
    } else {
        children.push({
            key: "maintenance/tasks",
            icon: "icon-etherium",
            label: "sidebar.maintenance-task",
            to: "/maintenance/tasks",
        });
    }

    // Department/staff only for admin or all
    if (isMainAdmin || isAll) {
        children.push(
            {
                key: "maintenance/departments",
                icon: "icon-etherium",
                label: "sidebar.maintenance-dept",
                to: "/maintenance/departments",
            },
            {
                key: "maintenance/staffs",
                icon: "icon-etherium",
                label: "sidebar.maintenance-staff",
                to: "/maintenance/staffs",
            },
        );
    }

    // Return full submenu or flat menu
    return isAll || isAdmin
        ? [
              {
                  key: "Maintenance",
                  icon: "icon-crm",
                  label: "sidebar.maintenance-module",
                  type: "submenu",
                  children,
              },
          ]
        : children;
};

export const getOleMenus = (isAll) =>
    isAll
        ? [
              {
                  key: "ole-management",
                  icon: "icon-crm",
                  label: "sidebar.ole-management-module",
                  type: "submenu",
                  children: [
                      {
                          key: "events",
                          icon: "icon-inbuilt-apps",
                          label: "sidebar.events",
                          to: "/events",
                      },
                      {
                          key: "ole-peoples",
                          icon: "icon-etherium",
                          label: "Peoples",
                          to: "/ole-peoples",
                      },
                      {
                          key: "pre-registration",
                          icon: "icon-etherium",
                          label: "Pre-registration",
                          to: "/pre-registration",
                      },
                      {
                          key: "housing-application",
                          icon: "icon-home",
                          label: "Housing Application",
                          to: "/housing-application",
                      },
                      {
                          key: "surveys",
                          icon: "icon-etherium",
                          label: "Surveys",
                          to: "/surveys",
                      },
                      {
                          key: "ole-app-menu",
                          icon: "icon-setting",
                          label: "Ole App Menu",
                          to: "/ole-app-menu",
                      },
                  ],
              },
          ]
        : [];
